<template>
  <div class="container">
    <h4 class="mt-3">Assignations :</h4>
    <table class="table table-bordered table-striped mt-3">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Individu</th>
          <th>Heures Estimées</th>
          <th>Heures Réelles</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(projectSubTask,index) in filteredProjectSubTasks" :key="index">
          <td>
            <div v-show="isEditable != projectSubTask.projectSubTaskGuid">{{ projectSubTask.name }}</div>
            <kez-input
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              :label="''"
              v-model="projectSubTask.name"
              :no-margin="true"
              :no-label-displayed="true"
              :no-padding="true"
              :id="projectSubTask.projectSubTaskGuid"
              validate="required"
            />
          </td>
          
          <td>
            <div
              v-show="isEditable != projectSubTask.projectSubTaskGuid"
            >{{ formattedWorker(projectSubTask.workerGuid) }}</div>
            <kez-select
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              :label="''"
              v-model="projectSubTask.workerGuid"
              :options="formattedActiveWorkers"
              :id="projectSubTask.projectSubTaskGuid"
              :no-label-displayed="true"
              :no-margin="true"
              :no-padding="true"
              validate="required"
            />
          </td>
          <td>
            <div
              v-show="isEditable != projectSubTask.projectSubTaskGuid"
            >{{ projectSubTask.estimatedHours }}</div>
            <kez-input
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              :label="''"
              v-model="projectSubTask.estimatedHours"
              :no-margin="true"
              :number="true"
              :no-label-displayed="true"
              :no-padding="true"
              :id="projectSubTask.projectSubTaskGuid"
              validate="required"
            />
          </td>
          <td>
            <div
              v-show="isEditable != projectSubTask.projectSubTaskGuid"
            >{{ projectSubTask.realHours }}</div>
            <kez-input
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              :label="''"
              v-model="projectSubTask.realHours"
              :no-margin="true"
              :no-label-displayed="true"
              :no-padding="true"
              :number="true"
              :id="projectSubTask.projectSubTaskGuid"
              validate="required"
            />
          </td>
          <td>
            <button
              v-show="isEditable != projectSubTask.projectSubTaskGuid"
              type="submit"
              class="btn btn-action btn-sm"
              @click="edit(projectSubTask.projectSubTaskGuid)"
            >
              <i class="material-icons">edit</i>
            </button>
            <button
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              type="submit"
              class="btn btn-action btn-sm"
              @click="cancel(projectSubTask.projectSubTaskGuid)"
            >
              <i class="material-icons">cancel</i>
            </button>
            <button
              v-show="isEditable == projectSubTask.projectSubTaskGuid"
              type="submit"
              class="btn btn-action btn-sm"
              @click="completeEdit(projectSubTask)"
            >
              <i class="material-icons">done</i>
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <Kez-input
              :label="''"
              v-model="projectSubTask.name"
              :no-margin="true"
              :no-label-displayed="true"
              :no-padding="true"
              validate="required"
            />
          </td>
          <td>
            <kez-select
              :label="'Individu'"
              v-model="projectSubTask.workerGuid"
              :options="formattedActiveWorkers"
              :no-label-displayed="true"
              :no-margin="true"
              :no-padding="true"
              validate="required"
            />

          </td>
          <td>
            <kez-input
              :label="''"
              v-model="projectSubTask.estimatedHours"
              :no-margin="true"
              :no-label-displayed="true"
              :no-padding="true"
              validate="required"
              :number="true"
              type="number"
            />
          </td>
          <td>
            <kez-input
              :label="''"
              v-model="projectSubTask.realHours"
              :no-margin="true"
              :no-label-displayed="true"
              :number="true"
              type="number"
              :no-padding="true"
              validate="required"
            />
          </td>
          <td>
            <button type="submit" class="btn btn-action btn-sm" @click="add(projectSubTask)">
              <i class="material-icons">done</i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezSelect from "@/components/_forms/KezSelect";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";
import KezInformationModal from "@/components/_modals/KezInformationModal";

export default {
  components: {
    KezInput,
    KezSelect,
    KezConfirmModal,
    KezInformationModal
  },
  props: ["projectId", "projectTaskId"],
  data() {
    return {
      isEditable: ""
    };
  },
  computed: {
    ...mapState("projectSubTasks", [
      "projectSubTasks",
      "filteredProjectSubTasks",
      "projectSubTask",
      
    ]),
    ...mapState("workers", ["workers", "worker", "activeWorkers", "activeWorker"]),
    ...mapGetters("workers", ["formattedWorkers", "formattedWorker", "formattedActiveWorkers", "formattedActiveWorker"])
  },
  watch: {
    projectSubTasks: {
      handler() {
        this.$store.dispatch(
          "projectSubTasks/getListByProject",
          this.$route.query.id
        );
      },
      immediate: true
    }
  },

  mounted() {
    this.$store.dispatch("projectSubTasks/getListByProject", this.$route.query.id);
    this.$store.dispatch("workers/getActiveList");
    this.$store.dispatch("workers/getAllList");
    this.$store.dispatch("workers/getList");
  },
  methods: {
    add() {
      if (
        this.projectSubTask.name != null &&
        this.projectSubTask.workerGuid != null &&
        this.projectSubTask.estimatedHours != null
      ) {
        this.projectSubTask.projectTaskGuid = this.projectTaskId;
        this.$store.dispatch("projectSubTasks/save", this.projectSubTask);
      }
    },
    edit(pstId) {
      this.isEditable = pstId;
    },
    cancel() {
      this.isEditable = "";
      this.$store.dispatch("projectSubTasks/getListByProject", this.projectId);
    },
    completeEdit(pst) {
      if (
        pst.name != null &&
        pst.workerGuid != null &&
        pst.estimatedHours != null
      ) {
        this.isEditable = "";
        this.$store.dispatch("projectSubTasks/save", pst);
      }
    }
  }
};
</script>
